"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.List = void 0;
var _productListClasses = _interopRequireDefault(require("../../containers/ProductListContainer/productListClasses"));
var _productListContext = require("../../contexts/productListContext");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const List = () => {
  const {
    renderItemComponent,
    items,
    renderListComponent,
    ListComponent
  } = (0, _productListContext.useProductList)();
  const hasDefinedListComponent = Boolean(ListComponent);
  if ((items.length < 1 || !renderItemComponent && !renderListComponent) && !hasDefinedListComponent) {
    return null;
  }
  if (hasDefinedListComponent) {
    return ListComponent;
  }
  if (renderListComponent) {
    return renderListComponent({
      items
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Root, {
    className: _productListClasses.default.list,
    children: items.map((item, index) => renderItemComponent?.({
      index,
      item
    }))
  });
};
exports.List = List;
